// @flow
import React from 'react';

const Expired = () => (
    <div>
        <h1>Your license is inactive</h1>
        <p>Please contact your Jira System Administrator to renew the addon license</p>
    </div>
);

export default Expired;
